import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, watch, nextTick, onMounted, onUnmounted } from 'vue';
import desensitize from '@/shared/filters/desensitize';
import { getScrollTop } from '@/shared/util';
import { detectEnv } from '@/shared/detect';
export default /*#__PURE__*/ _defineComponent({
    __name: 'captcha-popup',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        phoneNumber: {
            type: [
                String,
                Number
            ],
            default: ''
        },
        showResend: {
            type: Boolean,
            default: true
        },
        maxlength: {
            type: Number,
            default: 4
        },
        autoStart: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        sender: {
            type: Function,
            default: function() {}
        }
    },
    emits: [
        "finish"
    ],
    setup: function(__props, param) {
        var expose = param.expose, emit = param.emit;
        var props = __props;
        var ac = ref(null);
        var captcha = ref('');
        watch(captcha, function(val) {
            if (val.length === props.maxlength) {
                var _ac_value;
                emit('finish', val);
                (_ac_value = ac.value) === null || _ac_value === void 0 ? void 0 : _ac_value.abort();
            }
        });
        var counting = ref(false);
        var countdown = ref(null);
        var sending = ref(false);
        // @exposed-api
        var send = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // 发送中或者倒计时中不再次发送验证码
                            if (sending.value || counting.value) {
                                return [
                                    2
                                ];
                            }
                            sending.value = true;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                props.sender(props.phoneNumber)
                            ];
                        case 2:
                            _state.sent();
                            counting.value = true;
                            return [
                                3,
                                4
                            ];
                        case 3:
                            sending.value = false;
                            return [
                                7
                            ];
                        case 4:
                            if (counting.value) {
                                nextTick(function() {
                                    var _countdown_value;
                                    (_countdown_value = countdown.value) === null || _countdown_value === void 0 ? void 0 : _countdown_value.start();
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function send() {
                return _ref.apply(this, arguments);
            };
        }();
        // @exposed-api
        var clear = function() {
            captcha.value = '';
        };
        // @exposed-api
        var reset = function() {
            var _countdown_value;
            captcha.value = '';
            counting.value = false;
            (_countdown_value = countdown.value) === null || _countdown_value === void 0 ? void 0 : _countdown_value.reset();
            // 如果是auto-start，则自动调用发送
            if (props.autoStart) {
                send();
            }
        };
        // @exposed-api
        var isCountingDown = function() {
            return counting.value;
        };
        /**
 * 倒计时结束
 */ var onCountdownFinish = function() {
            var _countdown_value;
            counting.value = false;
            (_countdown_value = countdown.value) === null || _countdown_value === void 0 ? void 0 : _countdown_value.reset();
        };
        var popup = ref(null);
        var position = ref('fixed');
        var transformY = ref('');
        /**
 * 更新短信验证码弹窗距离顶部的位置
 * 支持 visual viewport的情况下让弹窗在visual viewport区域内居中
 */ var setOffsetTop = function() {
            var y = 20;
            if (window.visualViewport) {
                var _popup_value;
                var _popup_value_$el_clientHeight;
                y = Math.max(y, (window.visualViewport.height - ((_popup_value_$el_clientHeight = (_popup_value = popup.value) === null || _popup_value === void 0 ? void 0 : _popup_value.$el.clientHeight) !== null && _popup_value_$el_clientHeight !== void 0 ? _popup_value_$el_clientHeight : 0)) / 2);
            }
            // iOS 真机在键盘唤起状态下fixed定位是失效的
            if (detectEnv.ios) {
                position.value = 'absolute';
                y += getScrollTop(window);
            }
            transformY.value = "".concat(y, "px");
        };
        /**
 * 初始验证码弹窗距离顶部的位置
 */ var INITIAL_TRANSFORM_Y = '150px';
        /**
 * 重置验证码弹窗具体顶部的位置
 */ var resetOffsetTop = function() {
            position.value = 'fixed';
            if (window.visualViewport) {
                setOffsetTop();
            } else {
                transformY.value = INITIAL_TRANSFORM_Y;
            }
        };
        // 输入框节点
        var input = ref(null);
        /**
 * 监听验证码弹窗展示状态
 */ watch(function() {
            return props.value;
        }, function(val) {
            if (val && props.autoStart && !counting.value) {
                send();
            }
            if (val) {
                nextTick(function() {
                    setOffsetTop();
                    // iOS无法拉起键盘，仅用于Android
                    if (detectEnv.android) {
                        var _input_value;
                        (_input_value = input.value) === null || _input_value === void 0 ? void 0 : _input_value.focus();
                    }
                });
            }
        });
        var focused = ref(false);
        /**
 * 输入框获得焦点时更新其位置
 */ var onInputFocus = function() {
            focused.value = true;
            setOffsetTop();
        };
        /**
 * 输入框失去焦点时重置其位置
 */ var onInputBlur = function() {
            focused.value = false;
            resetOffsetTop();
        };
        /**
 * 监听visual viewport
 * 仅支持 Chrome 61+/Safari 13
 */ var watchVisualViewport = function() {
            if (!window.visualViewport) return;
            window.visualViewport.addEventListener('resize', setOffsetTop);
            window.visualViewport.addEventListener('scroll', setOffsetTop);
        };
        onMounted(function() {
            watchVisualViewport();
        });
        /**
 * 解除监听visual viewport
 * 仅支持 Chrome 61+/Safari 13
 */ var unwachVisualViewport = function() {
            if (!window.visualViewport) return;
            window.visualViewport.removeEventListener('resize', setOffsetTop);
            window.visualViewport.removeEventListener('scroll', setOffsetTop);
        };
        onUnmounted(function() {
            unwachVisualViewport();
        });
        /**
 * 通过Web OTP自动填充验证码
 * Chrome 93+ 对短信格式有要求
 */ var watchSMS = function() {
            if ('OTPCredential' in window) {
                ac.value = new AbortController();
                nextTick(function() {
                    var _ac_value;
                    navigator.credentials.get({
                        // @ts-expect-error 短信验证码
                        otp: {
                            transport: [
                                'sms'
                            ]
                        },
                        signal: (_ac_value = ac.value) === null || _ac_value === void 0 ? void 0 : _ac_value.signal
                    }).then(function(otp) {
                        // @ts-expect-error 短信验证码
                        captcha.value = otp === null || otp === void 0 ? void 0 : otp.code;
                    }).catch(function() {});
                });
            }
        };
        onMounted(function() {
            watchSMS();
        });
        /**
 * 解除监听Web OTP
 */ var unwatchSMS = function() {
            var _ac_value;
            (_ac_value = ac.value) === null || _ac_value === void 0 ? void 0 : _ac_value.abort();
        };
        onUnmounted(function() {
            unwatchSMS();
        });
        expose({
            send: send,
            clear: clear,
            reset: reset,
            isCountingDown: isCountingDown
        });
        return {
            __sfc: true,
            props: props,
            emit: emit,
            ac: ac,
            captcha: captcha,
            counting: counting,
            countdown: countdown,
            sending: sending,
            send: send,
            clear: clear,
            reset: reset,
            isCountingDown: isCountingDown,
            onCountdownFinish: onCountdownFinish,
            popup: popup,
            position: position,
            transformY: transformY,
            setOffsetTop: setOffsetTop,
            INITIAL_TRANSFORM_Y: INITIAL_TRANSFORM_Y,
            resetOffsetTop: resetOffsetTop,
            input: input,
            focused: focused,
            onInputFocus: onInputFocus,
            onInputBlur: onInputBlur,
            watchVisualViewport: watchVisualViewport,
            unwachVisualViewport: unwachVisualViewport,
            watchSMS: watchSMS,
            unwatchSMS: unwatchSMS,
            desensitize: desensitize
        };
    }
});
